import type { CSSProperties } from 'react';

import { Spinner } from '@treneo/shared/ui';

const CONTAINER_STYLE: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: '#f5f5f5',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '16px',
  fontFamily: 'Roboto, sans-serif',
  fontSize: '16px',
  color: '#333'
};

export const BootstrapLoadingScreen = () => (
  <div style={CONTAINER_STYLE} role='status' aria-label='Loading application'>
    <Spinner size={40} />
    <p>Loading...</p>
  </div>
);
